import { _ as _object_spread } from "@swc/helpers/_/_object_spread";
import { isNotUndefined } from "@faire/web--source/common/typescriptUtils";
import { ICartItemIssue } from "@faire/web-api--source/indigofair/data/ICartItemIssue";
import { IFixCartItemIssueRequest } from "@faire/web-api--source/indigofair/data/IFixCartItemIssueRequest";
import isEqual from "lodash/isEqual";
export var ICartItemForFixCart;
(function(ICartItemForFixCart) {
    ICartItemForFixCart.build = function(partial) {
        return _object_spread({
            token: "",
            product_token: "",
            product_option_token: "",
            customizations: [],
            quantity: 0,
            cart_item_issues: []
        }, partial !== null && partial !== void 0 ? partial : {});
    };
})(ICartItemForFixCart || (ICartItemForFixCart = {}));
export var getCartItemFixes = function(item) {
    var includesQuantityFix = false;
    var fixes = item.cart_item_issues.map(function(issue) {
        // if the only action available is to remove, then the fix is to remove
        if (isEqual(issue.actions, [
            ICartItemIssue.Action.REMOVE
        ])) {
            var _issue_cart_item_token;
            return IFixCartItemIssueRequest.ICartItemFix.build({
                cart_item_token: (_issue_cart_item_token = issue.cart_item_token) !== null && _issue_cart_item_token !== void 0 ? _issue_cart_item_token : item.token,
                remove_action: {}
            });
        }
        // acknowledge if we can
        if (issue.actions.includes(ICartItemIssue.Action.ACK)) {
            var _issue_cart_item_token1;
            return IFixCartItemIssueRequest.ICartItemFix.build({
                cart_item_token: (_issue_cart_item_token1 = issue.cart_item_token) !== null && _issue_cart_item_token1 !== void 0 ? _issue_cart_item_token1 : item.token,
                ack_action: {
                    acked_value: issue.updated_cart_information
                }
            });
        }
        var _issue_cart_item_token2;
        // if we cannot acknowledge and we don't have to remove, the issue is quantity related
        // use the suggested quantity passed from the BE to fix. We can only include a single quantity fix per issue
        var fix = !includesQuantityFix ? IFixCartItemIssueRequest.ICartItemFix.build({
            cart_item_token: (_issue_cart_item_token2 = issue.cart_item_token) !== null && _issue_cart_item_token2 !== void 0 ? _issue_cart_item_token2 : item.token,
            change_quantity_action: {
                new_quantity: issue.suggested_quantity
            }
        }) : undefined;
        includesQuantityFix = true;
        return fix;
    });
    return fixes.filter(isNotUndefined);
};
